<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <h1 class="display-4">
          All Users
        </h1>
      </div>
    </div>
    <div class="container">
      <div
        class="list-item d-flex d-flex"
        v-for="user in users"
        :key="user.uid"
      >
        <router-link :to="'/user/' + user.id">{{ user.name }}</router-link>
        <div
          v-if="currentUser.admin"
          class="icon-20"
          @click="deleteBook(user.id)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class=" pl-2">
            <path
              viewBox="0 0 11 13"
              d="M4.496 0C3.676 0 3 .676 3 1.496V2H0v1h1v8.5c0 .824.676 1.5 1.5 1.5h6c.824 0 1.5-.676 1.5-1.5V3h1V2H8v-.504C8 .676 7.324 0 6.504 0H4.496zm0 1h2.008c.281 0 .496.215.496.496V2H4v-.504C4 1.215 4.215 1 4.496 1zM2 3h7v8.5c0 .281-.219.5-.5.5h-6a.494.494 0 01-.5-.5V3zm1 1v7h1V4H3zm2 0v7h1V4H5zm2 0v7h1V4H7z"
              fill="currentColor"
              fill-rule="nonzero"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from 'firebase';
import { mapState } from 'vuex';

export default {
  computed: mapState({
    users: state => state.users,
    currentUser: state => state.currentUser,
  }),
  created() {
    this.$store.dispatch('fetchUsers');
    this.$store.dispatch('fetchCurrentUser');
  },
  methods: {
    deleteUser(id) {
      this.$store.dispatch('removeUser', id);
    },
  },
};
</script>
